<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p><span style="font-size: 20px;"><strong>转化医学研究计划项目背景：</strong></span></p><p>当代产业“制造”让位于“设计”，“设计”寄托于“推广”，一件设计独特，制造精良的产品，往往要在进行市场推广之后才能广为人知，实现市场价值，创取润。纵观当今市场，各类产品丰富多样，产品的推广模式却仅限于：电视媒体，络，杂志，报纸这四种方式。</p><p><span style="font-size: 20px;"><strong>技术路径：</strong></span></p><p><span style="font-size: 20px;"><span style="font-size: 14px;"><img src="https://s2.d2scdn.com/2019/12/18/Fj4PIfShdObBm8B7sJbO49ZFQvZL.jpg"/></span><strong><span style="font-size: 14px;"></span><br/></strong></span> </p>'
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/plan/index.vue